import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatNavigationService {
  readonly targetPrescriptionId = signal<string | null>(null);
  readonly targetThreadId = signal<string | null>(null);
  readonly activeTab = signal<number>(0);

  /**
   * Switch to prescriptions tab and highlight a specific prescription
   */
  switchToPrescriptionTab(prescriptionId: string): void {
    this.activeTab.set(1);
    this.targetPrescriptionId.set(prescriptionId);
  }

  /**
   * Navigate to specific thread (used by push notifications)
   */
  navigateToThread(threadId: string): void {
    this.targetThreadId.set(threadId);
  }

  /**
   * Clear the target prescription highlighting
   */
  clearTargetPrescription(): void {
    this.targetPrescriptionId.set(null);
  }

  /**
   * Clear the target thread
   */
  clearTargetThread(): void {
    this.targetThreadId.set(null);
  }

  /**
   * Manually set the active tab
   */
  setActiveTab(index: number): void {
    this.activeTab.set(index);
  }
}
